import { render, staticRenderFns } from "./QuestionList.vue?vue&type=template&id=025ec0d2&scoped=true"
import script from "./QuestionList.vue?vue&type=script&lang=js"
export * from "./QuestionList.vue?vue&type=script&lang=js"
import style0 from "./QuestionList.vue?vue&type=style&index=0&id=025ec0d2&prod&lang=less"
import style1 from "./QuestionList.vue?vue&type=style&index=1&id=025ec0d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025ec0d2",
  null
  
)

export default component.exports